export const ASC_ORD = 'asc';
export const DESC_ORD = 'desc';

export const TOKEN_TO_DOLLAR_RATIO = 0.1;
export const DOLLAR_TO_DOLLAR_RATIO = 1;

export const ADMIN_AREA_TABLE_DEFAULTS = {
  page: 0,
  perPage: 25,
  order: ASC_ORD,
  orderBy: 'dateModified',
};

export const CASHOUT_APPROVAL_TABLE_DEFAULTS = {
  page: 0,
  perPage: 25,
  order: DESC_ORD,
  orderBy: 'balance',
};
